import React from 'react';

import { useSelector } from 'react-redux';

import { Box, xcss } from '@atlaskit/primitives';

import { useIntl } from 'src/hooks/intl';
import { getConversationsGlobal } from 'src/selectors/conversation-selectors';

import { PullRequestConversation } from '../../containers/conversation/pull-request-conversation';

import messages from './pull-request-add-global-conversation.i18n';

const styles = xcss({
  marginTop: 'space.200',
  marginBottom: 'space.200',
  paddingBottom: 'space.200',
});

export const PullRequestAddGlobalConversation = React.memo(() => {
  const [conversation] = useSelector(getConversationsGlobal);
  const intl = useIntl();

  const conversationId = conversation ? conversation.conversationId : null;
  const placeholder = intl.formatMessage(messages.addGlobalConversation);

  return (
    <Box
      as="section"
      data-qa="conversations-global-style"
      aria-label={placeholder}
      xcss={styles}
    >
      <PullRequestConversation
        loginLinkText={intl.formatMessage(
          messages.loginLinkTextGlobalConversation
        )}
        // no limit on how deeply nested global conversation threads can get
        maxCommentNesting={undefined}
        placeholder={placeholder}
        portalParentId={`portal-parent-pr-global-conversation-${conversationId}`}
        // global comments use a basic editor without prepending @-mentions
        renderCommentWithReplyMention={false}
        commentThreads={[]}
      />
    </Box>
  );
});
